import { UserManagementTableUIModel } from "src/store/models/ui/userManagement/userManagementTable";

export const encooUserManagementUIModels = {
  UserManagementTable: UserManagementTableUIModel,
};
